import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import { di } from 'react-magnetic-di';
import Button, { ButtonGroup } from '@atlaskit/button';
import { Label } from '@atlaskit/form';
import Select from '@atlaskit/select';
import { ErrorBoundary } from '@atlassian/proforma-common-core/jira-common';
import { ProformaIntlProvider } from '@atlassian/proforma-utils/intl-provider';
import lazyMessages from '../../i18n/lazy';
import { FormCardIcon } from '../../ui/form-card-index/form-card/form-card-header-new/form-card-icon';
import { useAddFormErrorUtils, useAddFormState } from '../controllers';
import { ErrorState } from './error-state';
import { messages } from './messages';
import { ButtonRow, IconSelect, IssueFormSelectorStyles } from './styled';
const IconOption = ({
  option,
  restrictionStatus
}) => /*#__PURE__*/React.createElement(IconSelect, null, /*#__PURE__*/React.createElement(FormCardIcon, {
  restrictionStatus: restrictionStatus,
  isSelecting: true
}), option);
const AddFormBase = ({
  onAdd,
  onCancel
}) => {
  const intl = useIntl();
  const {
    forms,
    isLoading,
    error
  } = useAddFormState();
  const [selectedForm, setSelectedForm] = useState(undefined);
  const handleOnAdd = () => {
    if (selectedForm) {
      onAdd(selectedForm);
    }
  };
  const buildSelectOptions = availableForms => {
    if (availableForms.recommended.length > 0 && availableForms.available.length > 0) {
      return [{
        label: intl.formatMessage(messages.addFormSelectGroupRecommended),
        options: availableForms.recommended
      }, {
        label: intl.formatMessage(messages.addFormSelectGroupOther),
        options: availableForms.available
      }];
    }

    // flatten object values to 1D-Array
    return Object.values(availableForms).flat();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, error ? /*#__PURE__*/React.createElement(ErrorState, null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IssueFormSelectorStyles, null, /*#__PURE__*/React.createElement(Select, {
    id: "AddFormSelector",
    instanceId: "proforma-form-system.add-form.ui.issue-form-selector.add-form-select",
    tabSelectsValue: true,
    isLoading: isLoading,
    options: forms ? buildSelectOptions(forms) : [],
    defaultMenuIsOpen: true,
    label: intl.formatMessage(messages.addFormSelectInputPlaceholder),
    placeholder: intl.formatMessage(messages.addFormSelectInputPlaceholder),
    autoFocus: true,
    onChange: _selectedForm => {
      if (_selectedForm && 'value' in _selectedForm) {
        setSelectedForm(_selectedForm);
      }
    },
    formatOptionLabel: option => /*#__PURE__*/React.createElement(IconOption, {
      option: option.label || intl.formatMessage(messages.emptyFormName),
      restrictionStatus: option.restrictionStatus
    }),
    labelId: "react-select-proforma-form-system.add-form.ui.issue-form-selector.add-form-select-placeholder"
  })), /*#__PURE__*/React.createElement(ButtonRow, null, /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
    appearance: "primary",
    onClick: handleOnAdd,
    isDisabled: selectedForm === undefined
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.addFormButton)), /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      setSelectedForm(undefined);
      onCancel();
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.cancelButton))))));
};
export const AddForm = props => {
  const {
    locale
  } = useIntl();
  const errorUtils = useAddFormErrorUtils();
  if (!errorUtils) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ProformaIntlProvider, {
    messages: lazyMessages,
    locale: locale
  }, /*#__PURE__*/React.createElement(ErrorBoundary, {
    errorUtils: errorUtils,
    renderError: () => /*#__PURE__*/React.createElement(ErrorState, null)
  }, /*#__PURE__*/React.createElement(AddFormBase, props)));
};